import React from 'react';
import { appLinks } from '../../config/appLinks';
import { AppleStoreIcon, GooglePlayIcon } from './StoreBrandIcons';

export type StorePlatform = 'ios' | 'android';
export type StoreCtaVariant = 'hero' | 'modal' | 'profile';

const COPY: Record<StorePlatform, { small: string; strong: string }> = {
  ios: {
    small: 'Download on the',
    strong: 'App Store',
  },
  android: {
    small: 'Get it on',
    strong: 'Google Play',
  },
};

const COMING_SOON = 'Coming Soon';

interface StoreDownloadCtaProps {
  store: StorePlatform;
  variant?: StoreCtaVariant;
}

/**
 * One store CTA. Uses appLinks for the destination.
 * When the URL is not configured, the control is disabled and does not navigate.
 */
const StoreDownloadCta: React.FC<StoreDownloadCtaProps> = ({ store, variant = 'hero' }) => {
  const href = store === 'ios' ? appLinks.ios : appLinks.android;
  const copy = COPY[store];
  const icon = store === 'ios' ? <AppleStoreIcon /> : <GooglePlayIcon />;
  const className =
    variant === 'hero'
      ? 'app-store-btn'
      : variant === 'modal'
        ? 'app-store-button'
        : 'edit-profile-app-only-button';

  const label = href ? (
    variant === 'profile' ? (
      <span>
        {copy.small} {copy.strong}
      </span>
    ) : (
      <div className={variant === 'hero' ? 'store-text' : undefined}>
        <small>{copy.small}</small>
        <strong>{copy.strong}</strong>
      </div>
    )
  ) : variant === 'profile' ? (
    <span>{COMING_SOON}</span>
  ) : (
    <div className={variant === 'hero' ? 'store-text' : undefined}>
      <strong>{COMING_SOON}</strong>
    </div>
  );

  const inner =
    variant === 'hero' ? (
      <div className="store-btn-content">
        <span className={store === 'android' ? 'store-icon store-icon--google' : 'store-icon'}>{icon}</span>
        {label}
      </div>
    ) : (
      <>
        <span className={store === 'android' ? 'store-icon store-icon--google' : 'store-icon'}>{icon}</span>
        {label}
      </>
    );

  if (!href) {
    return (
      <button type="button" className={className} disabled aria-disabled="true">
        {inner}
      </button>
    );
  }

  return (
    <a className={className} href={href} target="_blank" rel="noopener noreferrer">
      {inner}
    </a>
  );
};

export default StoreDownloadCta;
